import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import {
  getGeneralSetting,
  getClientAnnouncement,
  getSmsConfiguration,
  updateClientAnnouncement,
  updateGeneralSettings,
  updateSmsConfiguration,
} from 'src/redux/settings/action';
import { useToast } from 'src/contexts/toast';
import SmsConfiguration from '../components/settings/SmsConfiguration';
import GeneralSettings from '../components/settings/GeneralSettings';
import ClientAnnouncementSettings from '../components/settings/ClientAnnouncementSettings';

const Settings = () => {
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const [settings, setSettings] = useState(null);
  const [clientAnnouncement, setClientAnnouncement] = useState(null);

  useEffect(() => {
    const settings2 = dispatch(getGeneralSetting());
    settings2.then((result) => {
      setSettings(result.settings[0]);
    });

    dispatch(getSmsConfiguration());

    dispatch(getClientAnnouncement())
      .then(setClientAnnouncement)
      .catch((error) => {
        showToast(`Failed to load client message: ${error.message}`, 'warning');
      });
  }, [dispatch, showToast]);

  const handleGeneralSetting = (values) => {
    dispatch(updateGeneralSettings(values));
    showToast('Settings updated successfully!');
  };

  const handleSmsConfiguration = (values) => {
    dispatch(updateSmsConfiguration(values));
    showToast('Settings updated successfully!');
  };

  const handleClientAnnouncement = async (values) => {
    try {
      const updated = await dispatch(updateClientAnnouncement(values));
      setClientAnnouncement(updated);
      showToast('Client message updated successfully!');
    } catch (error) {
      showToast(`Failed to update client message: ${error.message}`, 'warning');
      throw error;
    }
  };

  return (
    <>
      <Helmet>
        <title>Washer - Settings</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          {clientAnnouncement && (
            <ClientAnnouncementSettings
              announcement={clientAnnouncement}
              handleClientAnnouncement={handleClientAnnouncement}
            />
          )}
          <Box sx={{ pt: clientAnnouncement ? 3 : 0 }}>
            <GeneralSettings
              handleGeneralSetting={handleGeneralSetting}
              settings={settings}
            />
          </Box>
          <Box sx={{ pt: 3 }}>
            <SmsConfiguration
              handleSmsConfiguration={handleSmsConfiguration}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Settings;
